import React from 'react';
import c from 'classnames';
import get from 'lodash/get';
import { PapiDeviation } from '@wix/da-papi-types';
import MinimalDumbo from '../MinimalDumbo';
import { DumboProps as Props } from '../types';
import s from './Commission.scss';

export function getFirstExample({ commission, textContent }: PapiDeviation) {
  if (!commission) {
    return;
  }

  return commission && commission.examples && commission.examples[0];
}

const Commission: React.FC<Props> = ({
  deviation,
  width,
  height,
  className,
  'aria-hidden': ariaHidden,
}) => {
  const example = get(deviation, 'coverImage') || getFirstExample(deviation);
  if (!example) {
    return (
      <div
        style={{ width, height }}
        className={c(s['default-background'], className)}
      />
    );
  }

  return (
    <MinimalDumbo
      className={className}
      deviation={example}
      width={width}
      height={height}
      aria-hidden={ariaHidden}
    />
  );
};

export default Commission;
